import { render, staticRenderFns } from "./DevicesSingleScreenFirmware.vue?vue&type=template&id=48e5f53b&"
import script from "./DevicesSingleScreenFirmware.vue?vue&type=script&lang=js&"
export * from "./DevicesSingleScreenFirmware.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports